import Highcharts from 'highcharts';

export default function chartFire(chartId) {
    if (!document.getElementById(chartId)) return;

    Highcharts.chart(chartId, {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent'
        },
        title: {
            text: 'Fire Brigade access obstructions in 2025'
        },
        xAxis: {
            categories: ['Fires', 'Local hazards'],
            labels: {
                style: {
                    fontSize: '14px'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Number of access obstructions'
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: 'Number of access obstructions: <b>{point.y}</b>'
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Access obstructions',
            data: [
                { y: 1355, color: '#e74c3c' },
                { y: 2143, color: '#f39c12' }
            ],
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: '14px'
                }
            }
        }]
    });
}
